import React, { Component, PropTypes } from "react";
import moment from "moment";
import { getYearDayModsByCompType } from "../dist/util";
import Month from "./Month";

class YearCalendar extends Component {
  static propTypes = {
    //startDate: PropTypes.object.isRequired,
    // endDate: PropTypes.object.isRequired,
    //  weekNumbers: PropTypes.bool,
    //  locale: PropTypes.string,
    // month: PropTypes.array,
    // yearHeaderFormat: PropTypes.string
  };

  static defaultProps = {
    locale: "en",
    yearHeaderFormat: "YYYY"
  };

  moment() {
    const localMoment = moment.apply(null, arguments);
    localMoment.locale(this.props.locale);
    return localMoment;
  }

  getMonthRange() {
    const start = this.moment(this.props.startDate);
    const end = this.moment(this.props.endDate);
    const size = end.diff(start, "month") + 1;

    return Array(size)
      .fill(0)
      .map((n, i) => start.clone().add(n + i, "months"));
  }

  render() {
    const {
      startDate,
      empLeaves,
      weekends,
      handleOpenModal,
      publicHolidays,
      employeeId
    } = this.props;

    // Process the entire year's leaves at once using the new year-wide function
    let allYearDayMods = getYearDayModsByCompType(
      "day",
      startDate,
      empLeaves,
      handleOpenModal,
      employeeId,
      publicHolidays,
      weekends // Pass weekends as officeBusinessDays parameter
    );

    return (
      <div className="yearCalOuter">

        {this.getMonthRange().map((date, i) => {
          // Filter the year's data for this specific month
          let monthDayMods = allYearDayMods.filter(mod => {
            if (!mod.date) return false;
            return mod.date.isSame(date, 'month');
          });

          return (
            <Month
              key={`month-${i}`}
              date={date}
              mods={monthDayMods}
              day={monthDayMods}
              monthNames={true}
              monthNameFormat="MMMM YYYY"
              weekdayNames={true}
              weekdayFormat="dd"
            />
          );
        })}
      </div>
    );
  }
}
export default YearCalendar;
